import React from 'react';
import { useTranslation } from 'react-i18next';
import CargomaticModal from '../../v2/modal';

const ShipmentClosedModal = (props) => {
  const {t} = useTranslation();
  const { onAccessorialClick, onCancelClick } = props;
  const renderBody = () => {
    return (
      <div>
        <h3>{t('SHIPMENT_CLOSED_CONGRATS')}</h3>
        <p>
          {t('SHIPMENT_CLOSED_CONGRATS_MESSAGE')}
        </p>
        <div className="mt-10 flex justify-around">
          <button onClick={onAccessorialClick} className="button button-green">
            {t('REQUEST_ACCESSORIAL_NOW')}
          </button>
          <button onClick={onCancelClick} className="button">
            {t('WILL_DO_LATER')}
          </button>
        </div>
      </div>
    );
  };
  return (
    <CargomaticModal
      style={{ top: '35%' }}
      dialogClassName="rounded-xl border-4 border-green-cm w-1/3"
      showHeader={false}
      show={props.show}
      onHide={() => {}}
      body={renderBody()}
    />
  );
};

export default ShipmentClosedModal;
